$(window).on("load", function() {

    var campPage = $('#campaign-page');
    if (campPage.length) {

        function createSVG() {

            var canvasHeight = campPage.height();
            var svg = new SVG("campaign-page").size("100%", canvasHeight);
            var nodes = svg.group();
            var links = svg.group();
            var firstNode = $('.starter-point');
            var offset = firstNode.offset();
            var width = firstNode.outerWidth();
            var height = firstNode.outerHeight();
            var centerX = offset.left;
            var centerY = offset.top;
            //var rect = svg.rect(100, 100);
            var starterNode = nodes.group().circle(height).addClass('real-marker').opacity(0.1);
            starterNode.move(centerX, centerY);
            loadMarkers();


            function loadMarkers() {
                // get elements in group
                $('.set-position').each(function (index, value) {
                    var thisNode = $(this);
                    var firstNodePos = thisNode.offset();
                    var height = thisNode.outerHeight();
                    var newElm = nodes.group().circle(height).opacity(0.1);
                    newElm.move(firstNodePos.left, firstNodePos.top).addClass('real-marker');
                }).promise().done(function () {
                    computeConnections();
                });
            }


            function computeConnections() {
                // get elements in group
                $('.real-marker').each(function (index, value) {
                    //console.log(this.instance.x(), this.instance.y());
                    var next = $(this).parent().next().find(':first-child');
                    var nextElement = null;
                    if (typeof next.attr('id') !== 'undefined') {
                        var ID = next.attr('id');
                        nextElement = SVG.get(ID);
                        //console.log(ID, nextElement);
                        var conn = this.instance.connectable({
                            container: links,
                            type: 'curved',
                            // targetAttach: 'perifery',
                            //sourceAttach: 'perifery',
                            color: '#4c4c4c'
                        }, nextElement);

                        conn.connector.stroke({
                            width: 10,
                            color: '#7e7e7e'
                        }).attr({
                            "stroke-dasharray": "20, 10"
                        }).addClass('path');
                    }
                }).promise().done(function () {
                    /*setTimeout(function () {
                     var dataVal = [];
                     $('.path').each(function (index, value) {
                     dataVal.push($(this).attr('d'));
                     });
                     var dataValArray = dataVal.join('');
                     var dummyPath = svg.path(dataValArray).fill('none').addClass('dummyPath');
                     // positionTheDot();
                     }, 2000);*/
                });


                /* rect.animate(8000, '<>').during(function(pos, morph, eased){
                 var path = SVG.get('path');
                 var p = path.pointAt(eased * length)
                 rect.center(p.x, p.y)
                 }).loop(true, true)*/

            }


            function positionTheDot() {
                // TODO: need to replace getTotalLength wiuth somethign that woprls
                // What percentage down the page are we?
                var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

                var thePath = document.getElementsByClassName('dummyPath');

                //console.log(thePath); // 1879.0966796875 (testet on Firefox Nightly 63.0a1)

                var pathLen = thePath.getTotalLength();
                // Get the position of a point at <scrollPercentage> along the path.
                var pt = thePath.pointAt(scrollPercentage * pathLen);

                // Position the red dot at this point
                var dot = rect;
                dot.setAttribute("transform", "translate(" + pt.x + "," + pt.y + ")");
            };

        }


        // setTimeout(function () {
        //     $(window).trigger('resize');
        // createSVG();
        //  }, 1000);

        /*$('.lazy-camp').lazy({
           /!* visibleOnly: false,
            // called once all elements was handled
            onFinishedAll: function () {
                createSVG();
            }*!/
            visibleOnly: false,
            threshold: 0,
            onFinishedAll: function() {
                alert('onFinishedAll');
            }
        });*/
        setTimeout(function () {
            createSVG();
        }, 500);


        var $dashOffset = $("path").css("stroke-dashoffset");
        $(window).on('scroll', function () {
            var $percentageComplete = (($(window).scrollTop() / ($("html").height() - $(window).height())) * 100);
            var $newUnit = parseInt($dashOffset, 10);
            var $offsetUnit = $percentageComplete * ($newUnit / 100);
            $("path").css("stroke-dashoffset", $newUnit - $offsetUnit);

        });

    }


    $(window).on('resize', function () {
        setTimeout(function () {
            $('svg').remove();
            createSVG();
        }, 100);
    });


});


